export function createDiagonalPattern(color: string, backgroundColor = '#fff', size = 16) {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d')!;
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, size, size);
    ctx.strokeStyle = color;
    ctx.lineWidth = 5;
    ctx.beginPath();

    for (let i = -16; i <= 32; i += 16) {
      ctx.moveTo(i, 16 + 2);
      ctx.lineTo(i + 16 + 4, -2);
    }

    ctx.stroke();

    return {
      image: canvas,
      repeat: 'repeat' as const,
    };
  } catch {
    return color;
  }
}

export function computeLabelWidth(chart: echarts.ECharts, cols: number) {
  const w = chart.getWidth();

  return Math.max(60, Math.floor(w / cols) - 20);
}
